import React from "react";
import { IoIosArrowForward } from "react-icons/io";

const InputFormDouble = ({ title, placeholderMin, placeholderMax }) => {
  return (
    <div className="mb-2.5 px-5">
      <p className="font-pop text-sm font-bold uppercase text-darkGreen">
        {title}
      </p>
      <div className="mb-2 grid grid-cols-5 items-stretch">
        <input
          type="number"
          className="border-[rgba(0,  47, 52, 0.36)] col-span-2 mr-2.5 border py-2 px-3.5 font-pop  text-xs font-semibold opacity-50 outline-none placeholder:font-pop placeholder:text-xs placeholder:font-semibold placeholder:opacity-50"
          placeholder={placeholderMin || ""}
        />
        <input
          type="number"
          className="border-[rgba(0, 47, 52, 0.36)] col-span-2 box-border border border-r-transparent py-2 px-3.5 font-pop 
          text-xs font-semibold opacity-50 outline-none placeholder:font-pop placeholder:text-xs placeholder:font-semibold placeholder:opacity-50"
          placeholder={placeholderMax || ""}
        />
        <button className="box-border flex h-full grow items-center justify-center border border-l-0 border-darkGreen border-opacity-[.36] bg-primary text-3xl text-white">
          <IoIosArrowForward />
        </button>
      </div>
    </div>
  );
};

export default InputFormDouble;
